import { create } from "zustand";

interface DarkModeStore {
  isCanvasDarkMode: boolean; // for toggling between light and dark mode for all storyboards
  isViewDarkMode: boolean; // for toggling between light and dark view mode in components

  // Canvas-specific dark mode states
  canvasDarkModeStates: Record<string, boolean>;
  // Track which canvases have had their initial dark mode detected
  canvasDarkModeDetected: Record<string, boolean>;
  setCanvasDarkMode: (canvasId: string, isCanvasDarkMode: boolean) => void;
  setCanvasDarkModeDetected: (canvasId: string, detected: boolean) => void;

  setViewDarkMode: (isViewDarkMode: boolean) => void;
}

export const useDarkModeStore = create<DarkModeStore>()((set, get) => ({
  isCanvasDarkMode: false,
  isViewDarkMode: false,
  canvasDarkModeStates: {},
  canvasDarkModeDetected: {},
  setCanvasDarkMode: (canvasId, isCanvasDarkMode) =>
    set((state) => ({
      isCanvasDarkMode: isCanvasDarkMode, // Also update the global state
      canvasDarkModeStates: {
        ...state.canvasDarkModeStates,
        [canvasId]: isCanvasDarkMode,
      },
    })),

  setCanvasDarkModeDetected: (canvasId, detected) =>
    set((state) => ({
      canvasDarkModeDetected: {
        ...state.canvasDarkModeDetected,
        [canvasId]: detected,
      },
    })),

  setViewDarkMode: (isViewDarkMode) => {
    set({ isViewDarkMode });
  },
}));
